import type { Op } from "sharedb/lib/client";

import type { RichTextOpType } from "../shared/types/sharedb";

import type { DocUpdateMeta } from "./ShareDBDoc";

const sourceOwnsLocalContentRender = (
  source?: unknown,
): source is { ownsLocalContentRender: true } =>
  Boolean(
    source &&
      typeof source === "object" &&
      "ownsLocalContentRender" in source &&
      source.ownsLocalContentRender === true,
  );

const isRichTextDeltaOp = (op: Op): boolean =>
  (op as RichTextOpType).t === "rich-text" &&
  Array.isArray((op as RichTextOpType).o) &&
  !("oi" in op || "li" in op || "ld" in op);

/**
 * ProseMirror already paints local typing. True when the source set
 * ownsLocalContentRender and every op is a rich-text delta.
 *
 * Still false (fan out): remote ops (source === false), structure (oi/li/ld), mixed batches.
 */
export const isSelfRenderedLocalUpdate = (meta?: DocUpdateMeta): boolean => {
  if (!sourceOwnsLocalContentRender(meta?.source)) return false;
  const ops = meta?.ops;
  if (!ops?.length) return false;
  return ops.every(isRichTextDeltaOp);
};
